// import { Platform } from "react-native";

import { Constants } from "../data/constants";
import { handleError } from "./ErrorHandlers";
// import { fetchBlob, getBase64 } from "./DownloadUtils";
import InvalidSessionError from "./InvalidSessionError";
import i18next from "i18next";
// import xmljs from "xml-js";


// const { XMLParser, XMLBuilder, XMLValidator} = require("fast-xml-parser");

export class HttpService {
  constructor() {
    this.Constants = new Constants();
  }
  async postJson(route, data, session_id, add_server_url = true) {
    let options = {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };

    let response = await fetch(`${route}`, options);
    if (route.includes("actuator")) {
      return response;
    }
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    let is_ok = response.status === 200;

    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }

    let json_body = await response.json();

    if (json_body.statusCode !== this.Constants.successCode) {
      if (json_body.statusCode === this.Constants.invalid_session) {
        throw new InvalidSessionError(json_body.statusMsg);
      } else {
        throw new Error(i18next.t(json_body.statusMsg));
      }
    }

    return json_body;
  }
  async verifyMFA(route, data, add_server_url = true) {
    let options = {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    };

    let response = await fetch(`${route}`, options);
    if (route.includes("actuator")) {
      return response;
    }
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    let is_ok = response.status === 200;

    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }

    let json_body = await response.json();

    if (json_body.statusCode !== this.Constants.successCode) {
      if (json_body.statusCode === this.Constants.invalid_session) {
        throw new InvalidSessionError(json_body.statusMsg);
      } else {
        throw new Error(i18next.t(json_body.statusMsg));
      }
    }

    return [json_body, response.headers.get("Authorization")];
  }

  async loginPostJson(route, data, add_server_url = true) {
    let options = {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: "Basic" + btoa(data.userEmail + ":" + data.userPassword),
      },
    };

    let response = await fetch(`${route}`, options);

    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    let is_ok = response.status === 200;

    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }

    let json_body = await response.json();

    if (json_body.statusCode !== this.Constants.successCode) {
      if (json_body.statusCode === this.Constants.invalid_session) {
        throw new InvalidSessionError(json_body.statusMsg);
      } else {
        throw new Error(i18next.t(json_body.statusMsg));
      }
    }

    return [json_body, response.headers.get("Authorization")];

    //return json_body;
  }




  async getJson(route, session_id = "", add_server_url = true) {
    let options = {
      method: "get",
      // body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };
    let response = await fetch(`${route}`, options);

    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    let is_ok = response.status === 200;
    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }

    let json_body = await response.json();
    if (json_body.statusCode !== this.Constants.successCode) {
      if (json_body.statusCode === this.Constants.invalid_session) {
        throw new InvalidSessionError(json_body.statusMsg);
      } else {
        throw new Error(json_body.statusMsg);
      }
    }

    return json_body;
  }

  async deleteJson(route, session_id, data, add_server_url = true) {
    let options = {
      method: "delete",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };
    let response = await fetch(`${route}`, options);

    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    let is_ok = response.status === 200;

    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }

    let json_body = await response.json();

    if (json_body.statusCode !== this.Constants.successCode) {
      if (json_body.statusCode === this.Constants.invalid_session) {
        throw new InvalidSessionError(json_body.statusMsg);
      } else {
        throw new Error(json_body.statusMsg);
      }
    }
    return json_body;
  }

  async putJson(route, data, session_id, add_server_url = true) {
    let options = {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };

    let response = await fetch(`${route}`, options);
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    let is_ok = response.status === 200;

    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }

    let json_body = await response.json();

    if (json_body.statusCode !== this.Constants.successCode) {
      if (json_body.statusCode === this.Constants.invalid_session) {
        throw new InvalidSessionError(json_body.statusMsg);
      } else {
        throw new Error(json_body.statusMsg);
      }
    }

    return json_body;
  }

  async uploadFile(route, file, session_id = "", additionalData = {}) {
    let data = new FormData();
    data.append("file", file);
    data.append("data", JSON.stringify(additionalData));
    let options = {
      method: "post",
      body: data,
      headers: {
        Authorization: session_id,
      },
    };
    let response = await fetch(`${route}`, options);
    let is_ok = response.status === 200;
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    if (!is_ok && !is_json) {
      throw new Error(i18next.t("Unexpected Error"));
    }

    if (is_json) {
      let json_body = await response.json();
      if (json_body.statusCode !== this.Constants.successCode) {
        if (json_body.statusCode === this.Constants.invalid_session) {
          throw new InvalidSessionError(json_body.statusMsg);
        } else {
          throw new Error(json_body.statusMsg);
        }
      }
      return json_body;
    }
  }
  async downloadFile(route, session_id = "") {
    let options = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };

    let response = await fetch(`${route}`, options);
    let is_ok = response.status === 200;
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }
    if (is_ok && !is_json) {
      let blob = await response.blob();
      return window.URL.createObjectURL(blob);
    }
    if (is_json) {
      let json_body = await response.json();
      if (json_body.statusCode !== Constants.response_success) {
        if (json_body.statusCode === Constants.invalid_session) {
          throw new InvalidSessionError(json_body.statusMsg);
        } else {
          throw new Error(json_body.statusMsg);
        }
      }
      return json_body;
    }
  }

  async downloadCallFlowFile(route, session_id = "") {
    let options = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };

    let response = await fetch(`${route}`, options);
    let is_ok = response.status === 200;
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }
    if (is_ok && !is_json) {
      let blob = await response.blob();
      return blob;
    }
    if (is_json) {
      let json_body = await response.json();
      if (json_body.statusCode !== Constants.response_success) {
        if (json_body.statusCode === Constants.invalid_session) {
          throw new InvalidSessionError(json_body.statusMsg);
        } else {
          throw new Error(json_body.statusMsg);
        }
      }
      return json_body;
    }
  }

  async uploadMultipleFile(
    route,
    fileCTI,
    fileWeb,
    session_id = "",
    additionalData = {}
  ) {
    let data = new FormData();
    data.append("fileCTI", fileCTI);
    data.append("fileWeb", fileWeb);
    data.append("data", JSON.stringify(additionalData));
    data.append("fileId", additionalData.fileId);

    let options = {
      method: "post",
      body: data,
      headers: {
        Authorization: session_id,
      },
    };
    let response = await fetch(`${route}`, options);
    let is_ok = response.status === 200;
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    if (!is_ok && !is_json) {
      throw new Error(i18next.t("Unexpected Error"));
    }

    if (is_json) {
      let json_body = await response.json();
      if (json_body.statusCode !== this.Constants.successCode) {
        if (json_body.statusCode === this.Constants.invalid_session) {
          throw new InvalidSessionError(json_body.statusMsg);
        } else {
          throw new Error(json_body.statusMsg);
        }
      }
      return json_body;
    }
  }

  async callVoiceMakerAPI(data) {
    let url = "https://developer.voicemaker.in/voice/api";
    let options = {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer 562b6080-7a02-11ed-984a-7537dc9efb35",
      },
    };

    try {
      let response = await fetch(url, options);
      let is_json =
        response.headers.get("Content-Type").indexOf("application/json") >= 0;
      let is_ok = response.status === 200;

      if (!is_ok && !is_json) {
        let text = await response.text();
        throw new Error(i18next.t("Unexpected Error"));
      }
      let json_body = await response.json();
      if (json_body.success) {
        let result = await fetch(json_body.path);
        let file = result.blob();
        return file;
      }
    } catch (e) {
      handleError(e);

      return null;
    }
  }

  async downloadFiles(route, data, session_id = "") {
    let options = {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: session_id,
      },
    };

    let response = await fetch(`${route}`, options);
    let is_ok = response.status === 200;
    let is_json =
      response.headers.get("Content-Type").indexOf("application/json") >= 0;
    if (!is_ok && !is_json) {
      let text = await response.text();
      throw new Error(i18next.t("Unexpected Error"));
    }
    if (is_ok && !is_json) {
      let blob = await response.blob();
      return window.URL.createObjectURL(blob);
    }
    if (is_json) {
      let json_body = await response.json();
      if (json_body.statusCode !== Constants.response_success) {
        if (json_body.statusCode === Constants.invalid_session) {
          throw new InvalidSessionError(json_body.statusMsg);
        } else {
          throw new Error(json_body.statusMsg);
        }
      }
      return json_body;
    }
  }


 





}

